import { useEffect, useMemo, useState } from 'react'

import throttle from 'lodash-es/throttle';

export default function useScrollProgress () {
  const [scrollProgress, setScrollProgress] = useState(0)
  const [totalHeight, setTotalHeight] = useState(0)
  const scrollProgressPercentage = useMemo(() => scrollProgress / totalHeight * 100, [scrollProgress, totalHeight])
  useEffect(() => {
    const onScroll = throttle(() => {
      const scrollElement = document.scrollingElement;
      if (scrollElement) {
        setScrollProgress(scrollElement.scrollTop);
      }
    }, 100);
    const onResize = throttle(() => {
      const scrollElement = document.scrollingElement;
      if (scrollElement) {
        setTotalHeight(scrollElement.scrollHeight - window.innerHeight);
      }
    }, 100);
    onResize()
    onScroll()
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    }
  }, [])
  return { scrollProgress, scrollProgressPercentage }
}